import { z } from 'zod/v4';

export const deviceSchema = z.object({
  deviceId: z.string(),
  externalId: z.string().nullable(),
  currentDataVersion: z.string(),
  status: z.number(),
  mapSetRegionDetails: z.array(
    z.object({
      region: z.string(),
      latestMapSetVersion: z.string(),
      fileSizeInBytes: z.number(),
      unpackedFileSizeInBytes: z.number(),
    })
  ),
});

export type Device = z.infer<typeof deviceSchema>;
